const bAutoCompleter = {
    mixins: [mixins, sendCaptcha],
    props: {
        value: {
            type: String,
            default: ''
        },
        handler:{
            type: String,
            default: ''
        },
        clickable:{ // if clickable then not use autocomplete with url but rather emit click event to parent
            type: Boolean,
            default: false
        },
        useCaptcha: {   
            type: Boolean,
            default: false
        },
        greReady: false,
        captchaSiteKey: "",
        captchaAction: ""
    },
    data() {
        return {
            loading: false,
            records: [],
            errorMsgs: [],
        }
    },
    template: 
    `<div class="b-auto-completer" :class="activeClass" @click="stopPropagate">
        <transition name="slide-down">
            <nav v-if="isActive" class="b-auto-completer__conts">
                <transition-group name="fade">
                    <div v-if="loading" class="circle-loader"></div>
                    <ul v-if="records.length && !loading">
                        <li :class="itemTypeClass(item)" v-for="item in records">
                            <a v-if="!clickable && item.url" :href="item.url">{{item.text}}</a>
                            <button v-else type="button" @click="clicked(item)">{{item.text}}</button>
                        </li>
                    </ul>
                </transition-group>                
            </nav>
        </transition>
    </div>`,
    mounted() {

        jQuery(window).on('click.autocomplete', (e) => {
            this.close()
        })
    },
    computed: {
        isActive(){
            return this.loading || this.records.length > 0
        },
        activeClass(){
            return ''
        }
    },
    beforeUnmount: function () {
        jQuery(window).off('click.autocomplete')
    },
    methods: {
        async doSearch() {

            if (this.handler !== '' && this.value !== '') {
                this.loading = true
                this.reset() 
                
                try {

                    var token = "";
                    if (this.useCaptcha) {
                        token = await this.callCaptcha()
                        if (token) {
                            this.updateToken(token)
                        }
                    }

                    axios
                        .post(this.handler, { value: this.value, recaptchaResponse: token })
                        .then((response) => {
                            var { hasError, errorMessages, data } = response.data;

                            if (hasError) {
                                this.handleError(errorMessages);
                                return false;
                            }

                            this.handleSuccess(data);

                        })
                    .catch((errors) => {
                        this.handleError([this.globalerror]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
                } catch (err) {
                    this.loading = false;
                    this.handleError(JSON.parse(err));
                }

            }
        },
        stopSearch(){
            this.reset() 
            this.loading = false
            this.close()
        },
        close(){
            this.$emit("closeAutocomplete")
        },
        handleError(messages) {
            this.loading = false
            this.errorMsgs = this.hasValue(messages) ? messages : [];
            this.$emit("searchFailed", this.errorMsgs)
        },
        handleSuccess(data) {
            
            if(data.length){
                this.records.push(...data);
                this.$emit("searchCompleted")
            } else {
                this.$emit("noData")
            }
        },
        reset(){
            this.records = []
        },
        itemTypeClass(item){
            if(!item.type)
                return 'b-auto-completer__item-li'

            if(item.type==='group'){
                return 'b-auto-completer__item-more'
            }
            return 'b-auto-completer__item-li'
        },
        stopPropagate(e){
            e.stopPropagation()
        },
        clicked(item){
            this.$emit("clicked", item)
        }
    }
}
